module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-plus-1362dd1a.svg";